import type { DataTable } from "../aidwops.types";

export function DataTables({ tables, loading }: { tables: DataTable[]; loading?: boolean }) {
  if (tables.length === 0) {
    if (!loading) return null;
    return (
      <div className="skeleton-card">
        <div className="skeleton skeleton-line" style={{ width: "30%", marginBottom: 12 }} />
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="skeleton-row">
            <div className="skeleton" />
          </div>
        ))}
      </div>
    );
  }
  return (
    <>
      {tables.map((table) => (
        <div key={table.id} className="card">
          <div className="card-header">
            <span className="ic">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="4" width="18" height="16" rx="1.6" stroke="currentColor" strokeWidth="1.7" />
                <path d="M3 10h18M9 4v16" stroke="currentColor" strokeWidth="1.7" />
              </svg>
            </span>
            <div>
              <div className="card-title">{table.title}</div>
              {table.detail && <div className="card-title-sub">{table.detail}</div>}
            </div>
          </div>
          {table.rows.length === 0 ? (
            <p className="section-sub">Nothing to show.</p>
          ) : (
            <div className="data-table-wrap">
              <table className="data-table">
                <thead>
                  <tr>
                    {table.columns.map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {table.rows.map((row, i) => (
                    <tr key={i}>
                      {row.map((cell, j) => (
                        <td key={j}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ))}
    </>
  );
}
